import(/* webpackMode: "eager" */ "/vercel/path0/app/get-started/page.tsx");
